/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * VisitOptimizeUnscheduledDtoBase
 * auto generated base class for the model VisitOptimizeUnscheduledDtoModel.
 */
export const VisitOptimizeUnscheduledDtoModelBase = ModelBase
  .named('VisitOptimizeUnscheduledDto')
  .props({
    __typename: types.optional(types.literal("VisitOptimizeUnscheduledDto"), "VisitOptimizeUnscheduledDto"),
    id: types.identifier,
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class VisitOptimizeUnscheduledDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
}
export function selectFromVisitOptimizeUnscheduledDto() {
  return new VisitOptimizeUnscheduledDtoModelSelector()
}

export const visitOptimizeUnscheduledDtoModelPrimitives = selectFromVisitOptimizeUnscheduledDto()
